import React, {Component} from 'react';
import {Card, Form, FormLayout, TextField, Button} from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider} from '@shopify/polaris';
import './login.css'
import {reqLogin} from "../../api/index";
import memory from '../../utils/memory';
import storage from '../../utils/storage';
import { Redirect } from 'react-router-dom';
import logo from '../../assets/logo.png'

//登陆的路由组件
export default class Login extends Component{
    
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            email:'',
            password:''
        };
      }

    handleSubmit = (event) => {
        if(this.state.email === '' || this.state.password === '')
        {
            alert('Please input your email and password!');
            return false;
        }

        this.setState({loading:true});
        
        reqLogin(this.state.email, this.state.password).then(
            response => {
                //保存用户数据和全局配置文件到内存
                let user_info = response.data.success.user_info
                let setting   = response.data.success.setting
                memory.user_info = user_info
                memory.setting   = setting

                storage.saveInfo('user_info', user_info)
                storage.saveInfo('setting', setting)
                this.props.history.replace('/')
            }
        ).catch(
            error => {
                alert('User email or password not correct!');
                this.setState({loading:false});
            }
        )
    }
    
    render () {
        if(memory.user_info !== '{}')
        {
            return <Redirect to="/" />
        }

        return (
            <div className="login">
                <AppProvider i18n={enTranslations}>
                    <Card sectioned>
                        <img className="logo" src={logo} alt='' />
                        <h1>Log In</h1>
                        <h2>Continue to your account</h2>
                        <Form onSubmit={this.handleSubmit}>
                            <FormLayout>
                                <TextField
                                value={this.state.email}
                                label="Email"
                                type="email"
                                onChange={val => this.setState({email: val})}
                                />

                                <TextField
                                value={this.state.password}
                                label="Password"
                                type="password"
                                onChange={val => this.setState({password: val})}
                                />
                                
                                <Button loading={this.state.loading} primary submit>Login</Button>
                            </FormLayout>
                        </Form>
                        <p className="join-us">
                            <span>No account?</span> <span onClick={() => this.props.history.replace('/signup')}>Join us</span>
                        </p>
                        <span className="forgot-password" onClick={() => this.props.history.replace('/forgotpassword')}>Forgot password?</span>
                    </Card>
                </AppProvider>
            </div>
        )
    }
}